import React from 'react'
import clsx from 'clsx'
import LandingTabs from './tabs'
import Box from '@material-ui/core/Box'
import Container from '@material-ui/core/Container'
import Grid from '@material-ui/core/Grid'
import Button from '@material-ui/core/Button'
import Hidden from '@material-ui/core/Hidden'
import Divider from '@material-ui/core/Divider'
import { Animated } from 'react-animated-css'
import Typography from '@material-ui/core/Typography'
import ArrowDown from 'assets/illustrations/aerce/arrow-down.svg'
import ArrowRight from 'assets/illustrations/aerce/arrow-right.svg'
import ImageBannerMobile from 'assets/illustrations/aerce/landing-banner-m.jpg'
import ImageBenefit1 from 'assets/illustrations/aerce/landing-benefit-implementation.svg'
import ImageBenefit2 from 'assets/illustrations/aerce/landing-benefit-license.svg'
import ImageFeature1 from 'assets/illustrations/landing-feature-followup.svg'
import ImageFeature2 from 'assets/illustrations/landing-feature-renovation.svg'
import ImageFeature3 from 'assets/illustrations/landing-feature-validation.svg'
import ImageLogosDesktop from 'assets/illustrations/aerce/landing-logos-d.png'
import ImageLogosMobile from 'assets/illustrations/aerce/landing-logos-m.png'
import useStyles from './styles'
import useTranslation from 'hooks/useTranslations'

const LandingAerce = () => {
  const classes = useStyles()
  const t = useTranslation()
  return (
    <>
      <Box pt={8} className={classes.landing}>
        <Grid container spacing={4} className={classes.banner}>
          <Container>
            <Grid
              item
              xs={12}
              md={6}
              lg={5}
              className={classes.bannerSecondBlock}
            >
              <Animated animationIn="fadeInRight" animationInDuration={1000}>
                <Typography variant="h1" className={classes.bannerTitle}>
                  {t('aerce:banner:title')}
                </Typography>
              </Animated>
              <Animated
                animationIn="fadeInRight"
                animationInDuration={1000}
                animationInDelay={200}
              >
                <Typography variant="body1" className={classes.bannerSubtitle}>
                  {t('aerce:banner:subtitle')}
                </Typography>
              </Animated>
              <Animated>
                <Box mb={3}>
                  <Hidden smUp>
                    <img
                      style={{ maxWidth: '187px', width: '50%' }}
                      src={ImageLogosMobile}
                      alt="{t('aerce:banner:title')}"
                    />
                  </Hidden>
                  <Hidden xsDown>
                    <img
                      style={{ maxWidth: '468px', width: '100%' }}
                      src={ImageLogosDesktop}
                      alt="{t('aerce:banner:title')}"
                    />
                  </Hidden>
                </Box>
              </Animated>
              <Animated
                animationIn="fadeInUp"
                animationInDuration={1000}
                animationInDelay={400}
              >
                <Button
                  variant="contained"
                  color="primary"
                  className={classes.bannerButton}
                  href={t('aerce:banner:button_url')}
                >
                  {t('aerce:banner:button')}
                </Button>
              </Animated>
            </Grid>
            <Grid item xs={12} md={6} lg={7}>
              <Box textAlign="center">
                <Hidden mdUp>
                  <img
                    style={{ maxWidth: '380px', width: '100%' }}
                    src={ImageBannerMobile}
                    alt="{t('aerce:banner:title')}"
                  />
                </Hidden>
              </Box>
            </Grid>
          </Container>
        </Grid>
        <Container>
          <Box pb={4}>
            <Grid container>
              <Grid item xs={12}>
                <Box textAlign="center">
                  <Typography variant="h2" className={classes.featureTitle}>
                    {t('aerce:benefit:title')}
                  </Typography>
                  <Typography
                    variant="body1"
                    className={classes.featureSubtitle}
                  >
                    {t('aerce:benefit:subtitle')}
                  </Typography>
                </Box>
              </Grid>
              <Hidden smDown>
                <Grid item xs={12} md={1} className={classes.feature} />
              </Hidden>
              <Grid item xs={12} md={5} className={classes.feature}>
                <img
                  className={clsx(classes.featureImage)}
                  src={ImageBenefit1}
                  alt={t('aerce:benefit:heading1')}
                />
                <Typography className={classes.featureHeading} variant="h2">
                  {t('aerce:benefit:heading1')}
                </Typography>
                <Typography className={classes.featureText} variant="body1">
                  {t('aerce:benefit:text1')}
                </Typography>
              </Grid>
              <Hidden smDown>
                <Divider
                  orientation="vertical"
                  flexItem
                  className={classes.featureDivider}
                />
              </Hidden>
              <Grid item xs={12} md={5} className={classes.feature}>
                <img
                  className={clsx(classes.featureImage)}
                  src={ImageBenefit2}
                  alt={t('aerce:benefit:heading2')}
                />
                <Typography className={classes.featureHeading} variant="h2">
                  {t('aerce:benefit:heading2')}
                </Typography>
                <Typography className={classes.featureText} variant="body1">
                  {t('aerce:benefit:text2')}
                </Typography>
              </Grid>
            </Grid>
          </Box>
          <LandingTabs />
        </Container>
        <Grid container className={classes.sectionDownload}>
          <Container>
            <Box py={2} textAlign="center">
              <Grid container>
                <Hidden xsDown>
                  <Grid item md={1} />
                </Hidden>
                <Grid item xs={12} md={6}>
                  <Typography
                    variant="h3"
                    className={classes.sectionDownloadTitle}
                  >
                    {t('aerce:section-download:title')}
                  </Typography>
                </Grid>
                <Grid item xs={12} md={1}>
                  <Hidden mdUp>
                    <img
                      src={ArrowDown}
                      alt="{t('aerce:section-download:title')}"
                    />
                  </Hidden>
                  <Hidden smDown>
                    <Box textAlign="center" pt={2}>
                      <img
                        src={ArrowRight}
                        alt="{t('aerce:section-download:title')}"
                      />
                    </Box>
                  </Hidden>
                </Grid>
                <Grid item xs={12} md={3}>
                  <Button
                    variant="contained"
                    color="primary"
                    className={classes.sectionDownloadButton}
                    href={t('aerce:section-download:button_url')}
                    target="_blank"
                  >
                    {t('aerce:section-download:button')}
                  </Button>
                </Grid>
              </Grid>
            </Box>
          </Container>
        </Grid>
        <Container>
          <Box py={4}>
            <Grid container>
              <Grid item xs={12}>
                <Box textAlign="center">
                  <Typography variant="h2" className={classes.featureTitle}>
                    {t('aerce:feature:title')}
                  </Typography>
                  <Typography
                    variant="body1"
                    className={classes.featureSubtitle}
                  >
                    {t('aerce:feature:subtitle')}
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={12} md={4} className={classes.feature}>
                <img
                  className={clsx(classes.featureImage)}
                  src={ImageFeature1}
                  alt={t('aerce:feature:heading1')}
                />
                <Typography className={classes.featureHeading} variant="h2">
                  {t('aerce:feature:heading1')}
                </Typography>
                <Typography className={classes.featureText} variant="body1">
                  {t('aerce:feature:text1')}
                </Typography>
              </Grid>
              <Hidden smDown>
                <Divider
                  orientation="vertical"
                  flexItem
                  className={classes.featureDivider}
                />
              </Hidden>
              <Grid item xs={12} md={4} className={classes.feature}>
                <img
                  className={clsx(classes.featureImage)}
                  src={ImageFeature2}
                  alt={t('aerce:feature:heading2')}
                />
                <Typography className={classes.featureHeading} variant="h2">
                  {t('aerce:feature:heading2')}
                </Typography>
                <Typography className={classes.featureText} variant="body1">
                  {t('aerce:feature:text2')}
                </Typography>
              </Grid>
              <Hidden smDown>
                <Divider
                  orientation="vertical"
                  flexItem
                  className={classes.featureDivider}
                />
              </Hidden>
              <Grid item xs={12} md={4} className={classes.feature}>
                <img
                  className={clsx(classes.featureImage)}
                  src={ImageFeature3}
                  alt={t('aerce:feature:heading3')}
                />
                <Typography className={classes.featureHeading} variant="h2">
                  {t('aerce:feature:heading3')}
                </Typography>
                <Typography className={classes.featureText} variant="body1">
                  {t('aerce:feature:text3')}
                </Typography>
              </Grid>
            </Grid>
          </Box>
        </Container>
        <Grid container className={classes.sectionBenefit}>
          <Container>
            <Grid item xs={12}>
              <Box textAlign="center">
                <Typography
                  variant="h2"
                  className={classes.sectionBenefitTitle}
                >
                  {t('aerce:section-benefit:title')}
                </Typography>
                <Typography
                  variant="body1"
                  className={classes.sectionBenefitText}
                >
                  {t('aerce:section-benefit:subtitle')}
                </Typography>
                <Box pt={6} pb={2}>
                  <Button
                    variant="contained"
                    color="primary"
                    className={classes.sectionBenefitButton}
                    href={t('aerce:section-benefit:button_url')}
                  >
                    {t('aerce:section-benefit:button')}
                  </Button>
                </Box>
              </Box>
            </Grid>
          </Container>
        </Grid>
      </Box>
    </>
  )
}

export default LandingAerce
